import PropTypes from 'prop-types'
import React, { useEffect, useState } from "react"
import { getUsers } from "../../store/admin/actions"
import { addDataEntryPlant, addDataEntryAnimal, getDataEntryPlants, getDataEntryAnimals } from "../../store/hackathon/actions"
import Dropzone from "react-dropzone"
import { connect } from 'react-redux'
import { StorageImage } from '@aws-amplify/ui-react-storage';

import { Storage } from '@aws-amplify/storage'
import {
  Container,
  Row,
  Col,
  Button,
  Input,
  Label,
  Card,
  CardBody,
  CardTitle,
  CardHeader,
  CardText,
  CardSubtitle,
  Form,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Media,
  Table,
} from "reactstrap"
import { Link } from "react-router-dom"

const Hackathon = props => {
   const [plantName, setPlantName] = useState()
   const [latinName, setLatinName] = useState()
   const [plantFamily, setPlantFamily] = useState()
   const [climate, setClimate] = useState()
   const [daysToHarvest, setDaysToHarvest] = useState()
   const [floweringWindow, setFloweringWindow] = useState()
   const [errors, setErrors] = useState({})
   const [minTemp, setMinTemp] = useState()
   const [maxTemp, setMaxTemp] = useState()
   const [typeOfHarvest, setTypeOfHarvest] = useState()
   const [yieldPerPlant, setYieldPerPlant] = useState()
   const [layer, setLayer] = useState()
   const [season, setSeason] = useState()
   const [guildFunction, setGuildFunction] = useState()
   const [size, setSize] = useState()
   const [spacing, setSpacing]= useState()
   const [minZone, setMinZone] = useState()
   const [maxZone, setMaxZone] = useState()
   const [harvestStart, setHarvestStart] = useState()
   const [harvestEnd, setHarvestEnd] = useState()
   const [pollination, setPollination] = useState()
   const [notes, setPlantNotes] = useState([])
   const [selectedIcon, setSelectedIcon] = useState([])
   const [selectedDesignerIcon, setSelectedDesignerIcon] = useState([])

   const { dataentryplants, dataentryanimals, onGetUsers, onAddDataEntryPlant, onAddDataEntryPest, onGetNeededPlants, onGetNeededPests } = props


const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }


const validate = () => {
    let tempErrors = {};
    tempErrors.name = plantName ? "" : "Plant Name is required.";
    tempErrors.latinName = latinName ? "" : "Latin Name is required.";
    tempErrors.plantFamily = plantFamily ? "" : "Plant Family is required";
    tempErrors.season = season ? "" : "Season is required";
    tempErrors.spacing = spacing ? "" : "Spacing between plants is required";
    tempErrors.climate = climate ? "" : "Climate is required";
    tempErrors.typeOfHarvest = typeOfHarvest ? "" : "Type of Harvest is required"
    tempErrors.maxTemp = minTemp ? "" : "Maximum temperature is required"
    tempErrors.minTemp = maxTemp ? "" : "Minimum temperature is required"
    tempErrors.minZone = minZone ? "" : "Minimum Zone is required"
    tempErrors.maxZone = maxZone ? "" : "Maximum Zone is required"
    tempErrors.maxZone = maxZone ? "" : "Maximum Zone is required"
    tempErrors.size = size ? "" : "Size is required"
    tempErrors.selectedIcon = selectedIcon.length>0 ? "" : "An icon for the plant card is required"
    tempErrors.selectedDesignerIcon = selectedDesignerIcon.length>0 ? "" : "An icon for the designer is required"
    if (season=="perennial") {
        tempErrors.guildFunction = guildFunction.length ? "" : "guildFunction is required"
        tempErrors.foodForestLayer = foodForestLayer ? "" : "foodForestLayer is required"
        if ((harvestStart=="" && harvestEnd=="") || floweringWindow=="") {
            tempErrors.window = "Either Flowering Window or harvest window is required"
        }
        tempErrors.foodForestLayer = foodForestLayer ? "" : "foodForestLayer is required"
    } else {
       tempErrors.daysToHarvest = daysToHarvest ? "" : "Days to Harvest is required"
       tempErrors.yieldPerPlant = yieldPerPlant ? "" : "Yield Per Plant is required"
    }
    setErrors(tempErrors);
    return Object.values(tempErrors).every(x => x === "");
  };


   function savePlant() {
      if (!validate()) {
        console.log("BADDDDDD form");
        return;
      }
      var plant = {
   name: plantName,
   searchName: plantName.toLowerCase(),
   "latin name": latinName,
   plant_family: plantFamily,
   climate: climate,
   daysToHarvest: daysToHarvest,
   floweringWindow: floweringWindow,
   minimumTemp: minTemp,
   maximumTemp: maxTemp,
   typeOfHarvest: typeOfHarvest,
   yield_per_plant_ounces: yieldPerPlant,
   notes: notes,
   USDAMin: minZone,
   USDAMax: maxZone,
   harvestWindow: monthNames[new Date(harvestStart).getMonth()] + "-" + monthNames[new Date(harvestEnd).getMonth()],
   size: size,
   spacing_between_plants: spacing,
   guildFunction: [guildFunction],
   season: season,
   foodForestLayer: layer,
   pollination: pollination
      };
    
     selectedIcon.map(file => {
          Storage.put("card_" + plant.searchName, file, {
               contentType: file.type
          }).then (result => {
            plant["s3_icon"] = "card_" + plant.searchName
            selectedDesignerIcon.map(file => {
                 Storage.put("planner_" + plant.searchName, file, {
                      contentType: file.type
                }).then (result => {
                   plant["s3_designer_icon"] = "planner_" + plant.searchName
                   alert ("You've added a plant to the database")
                   setPlantName() 
                   setLatinName() 
    setPlantFamily() 
   setClimate()
    setDaysToHarvest()
    setFloweringWindow()
   setErrors({})
   setMinTemp()
    setTypeOfHarvest()
    setYieldPerPlant()
   setLayer()
   setSeason()
    setGuildFunction()
    setSize()
   setSpacing()
    setMinZone()
    setMaxZone()
    setHarvestStart()
   setHarvestEnd()
   setPollination()
    setPlantNotes([])
   setSelectedIcon([])
    setSelectedDesignerIcon([])

                   onAddDataEntryPlant(plant)
                })
                .catch(err => {
                     console.log(err)

                });
     });
           
          })
          .catch(err => {
             console.log(err)

          });
     });



	
   }

  function handleIcon(files) {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size)
      })
    )

    setSelectedIcon(files)
  }

   function handleDesignerIcon(files) {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size)
      })
    )

    setSelectedDesignerIcon(files)
  }



  useEffect (() => {

  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}

             <Card outline className="border">
                <CardHeader  style={{backgroundColor:'#AEBFFF'}}>
                  <h5>
                     2024 SAGE Hackathon
                  </h5>
                </CardHeader>
                <CardBody>
	           <p>Welcome to our First Quarter SAGE Hackathon!  In this hackathon our mission is to enter in as much plant information into the SAGE database as possible.  While doing this, we'll learn about what a database is, what kinds of databases there are, and what database SAGE uses.</p>
	           <p>In the forms below, you can choose to enter in information about plants. You'll add interesting plants that you'd like to grow in your garden or other edible or useful plants. Choose Plant from the Radio choice below and fill out the required plant information.  If you just add a plant, you'll get 5 points.</p>
	           <p>Once you've added a plant by clicking the Save button, you'll receive your points and the form will reset.  Make sure that you are sure about all your information before you hit the Save button because the form will clear out all your answers.  You can go to the Leaderboard to see your current total for points, as well as see how everyone else is doing.  You'll also be able to see the plants that you've entered into the SAGE database from the Leaderboard.</p>
	           <p>If your score is under 25, you are still an apprentice.  If you can get more than 25 points, you'll be promoted to a journeyman.  Finally, if you can get more than 50 points, you'll be promoted to the highest level, a master.  Journeymen and masters get special prizes to help you become a better gardener, so we encourage you to push hard during these 2 hours to see how far you can go.</p> </CardBody>
              </Card>

	 <Row>
	 </Row>
	  <Form>
	      <Row style={{marginBottom: "5px"}}>
              <Col><b>Name of Plant</b></Col>
              <Col>
                   <Input type="text"  onChange={event => {
                               setPlantName(event.target.value);
                          }}
>
                   </Input>
                   {errors.name && <p>{errors.name}</p>}
              </Col>
         </Row>
 <Row style={{marginBottom: "5px"}}>
              <Col><b>Latin Name</b></Col>
              <Col>
                   <Input type="text"  onChange={event => {
                               setLatinName(event.target.value);
                          }}
>
                   </Input>

                   {errors.latinName && <p>{errors.latinName}</p>}
              </Col>
         </Row>
		   <Row style={{marginBottom: "5px"}}>
              <Col><b>Plant Family (taxonomic family, for example, brussels sporuts are in the Brassica family)</b></Col>
              <Col>
                   <Input type="text"  onChange={event => {
                               setPlantFamily(event.target.value);
                          }}
>
                   </Input>
                   {errors.plantFamily && <p>{errors.plantFamily}</p>}
              </Col>
         </Row>
          <Row>
              <Col md={6}><b>Permaculture Function</b></Col>
              <Col md={6}>
                    <Input type="select" onChange={event => {
                               setGuildFunction(event.target.value);
                          }}>
                          <option value=""></option>
                          <option value="Star Player">Star Player</option>
                          <option value="Ground Cover">Ground Cover</option>
                          <option value="Pollinator">Pollinator</option>
                          <option value="Insectary">Insectary</option>
		          <option value="Food/Fiber">Food/Fiber</option>
		          <option value="Nitrogen Fixer">Nitrogen Fixer</option>
                          <option value="Dynamic Accumulator">Dynamic Accumulator</option>
                          <option value="Erosion Control">Erosion Control</option>
		           <option value="Medicinal Plants">Medicinal Plants</option>
		           <option value="Wildlife Benefit">Wildlife Benefit</option>
                    </Input>
              </Col>
         </Row>
 <Row>
              <Col md={6}><b>Climate</b></Col>
              <Col md={6}>
                    <Input type="select" onChange={event => {
                               setClimate(event.target.value);
                          }}>
                          <option value=""></option>
                          <option value="Subtropical">Subtropical</option>
                          <option value="Tropical">Tropical</option>
                          <option value="Temperate">Temperate</option>
		          <option value="Mediterranean">Mediterranean</option>
                          <option value="Cold Desert">Cold Desert</option>
                          <option value="Hot Desert">Hot Desert</option>
                          <option value="Cool Temperate">Cool Temperate</option>
                    </Input>
                   {errors.climate && <p>{errors.climate}</p>}
              </Col>
         </Row>
         <Row>
              <Col md={6}><b>USDA Min Zone</b></Col>
              <Col md={6}>
                    <Input type="select" onChange={event => {
                               setMinZone(event.target.value);
                          }}>
                          <option value=""></option>
                          <option value="1">1a-1b</option>
                          <option value="2">2a-2b</option>
                          <option value="3">3a-3b</option>
                          <option value="4">4a-4b</option>
                          <option value="5">5a-5b</option>
                          <option value="6">6a-6b</option>
                          <option value="7">7a-7b</option>
                          <option value="8">8a-8b</option>
                          <option value="9">9a-9b</option>
                          <option value="10">10a-10b</option>
                          <option value="11">11a-11b</option>
                          <option value="12">12a-12b</option>
                    </Input>
                   {errors.minZone && <p>{errors.minZone}</p>}
              </Col>
         </Row> 
         <Row>
              <Col md={6}><b>USDA Max Zone</b></Col>
              <Col md={6}>
                    <Input type="select" onChange={event => {
                               setMaxZone(event.target.value);
                          }}>
                          <option value=""></option>
                          <option value="1">1a-1b</option>
                          <option value="2">2a-2b</option>
                          <option value="3">3a-3b</option>
                          <option value="4">4a-4b</option>
                          <option value="5">5a-5b</option>
                          <option value="6">6a-6b</option>
                          <option value="7">7a-7b</option>
                          <option value="8">8a-8b</option>
                          <option value="9">9a-9b</option>
                          <option value="10">10a-10b</option>
                          <option value="11">11a-11b</option>
                          <option value="12">12a-12b</option>
                    </Input>

                   {errors.maxZone && <p>{errors.maxZone}</p>}
              </Col>
         </Row>
         <Row>
              <Col md={6}><b>Layer</b></Col>
              <Col md={6}>
                    <Input type="select" onChange={event => {
                               setLayer(event.target.value);
                          }}>
                          <option value=""></option>
                          <option value="Canopy">Canopy</option>
                          <option value="Subcanopy">Subcanopy</option>
                          <option value="Shrub">Shrub/Bush</option>
                          <option value="Herbaceous">Herbaceous</option>
                          <option value="Ground Cover">Ground Cover</option>
                          <option value="Root Crop">Root Crop</option>
                          <option value="Vining">Vining</option>
                    </Input>

                   {errors.layer && <p>{errors.layer}</p>}
              </Col>
         </Row>
	  <Row style={{marginBottom: "5px"}}>
              <Col><b>Season</b></Col>
              <Col>
                    <Input type="select"  onChange={event => {
                               setSeason(event.target.value);
                          }}>
                          <option value=""></option>
                          <option value="Perennial">Perennial</option>
                          <option value="Biennial">Biennial</option>
                          <option value="Annual">Annual</option>
                    </Input>

                   {errors.season && <p>{errors.season}</p>}
              </Col>
         </Row>
         {season!='Perennial' &&
         <div>
       <Row style={{marginBottom: "5px"}}>
              <Col><b>Days To Harvest (Number of days from transplant to harvest)</b></Col>
              <Col>
                   <Input type="text"  onChange={event => {
                               setDaysToHarvest(event.target.value);
                          }}
>
                   </Input>

                   {errors.window && <p>{errors.window}</p>}
              </Col>
         </Row>
         </div>
       }
       {season=='Perennial' &&
	       <div>
       <Row style={{marginBottom: "5px"}}>
              <Col><b>Flowering Window (this is only useful for things like fruit trees or berry bushes, where you are trying to figure out when the flowers appear so they don't get damaged by frost)</b></Col>
              <Col>
                   <Input type="text"  onChange={event => {
                               setFloweringWindow(event.target.value);
                          }}
>
                   </Input>

                   {errors.window && <p>{errors.window}</p>}
              </Col>
         </Row>
         <Row style={{marginBottom: "5px"}}>
              <Col><b>Harvest Window Start (when you start getting fruit)</b></Col>
              <Col>
          <Input type="date"
                                      onChange={event => {
                               setHarvestStart(event.target.value);
                          }}
                      />

                   {errors.window && <p>{errors.window}</p>}
                      </Col>
          </Row>

         <Row style={{marginBottom: "5px"}}>
              <Col><b>Harvest Window End (when you stop getting fruit)</b></Col>
              <Col>
          <Input type="date"
                                      onChange={event => {
                               setHarvestEnd(event.target.value);
                          }}
                      />
                      </Col>
          </Row>
</div>
       }
          <Row style={{marginBottom: "5px"}}>
              <Col><b>Type of Harvest</b></Col>
              <Col>
                    <Input type="select" onChange={event => {
                               setTypeOfHarvest(event.target.value);
                          }}>
                          <option value=""></option>
                          <option value="Berries">Berries</option>
		          <option value="Nuts">Nuts</option>
                          <option value="Fruit">Fruit</option>
                          <option value="Leaves">Leaves</option>
                          <option value="Roots">Roots</option>
                          <option value="Flowers">Flowers</option>
                    </Input>

                   {errors.typeOfHarvest && <p>{errors.typeOfHarvest}</p>}
              </Col>
         </Row>
          <Row style={{marginBottom: "5px"}}>
              <Col><b>Minimum Temperature (F)</b></Col>
              <Col>
                   <Input type="text"  onChange={event => {
                               setMinTemp(event.target.value);
                          }}
>
                   </Input>
              </Col>
         </Row>
          <Row style={{marginBottom: "5px"}}>
              <Col><b>Maximum Temperature (F)</b></Col>
              <Col>
                   <Input type="text"  onChange={event => {
                               setMaxTemp(event.target.value);
                          }}
>
                   </Input>

                   {errors.maxTemp && <p>{errors.maxTemp}</p>}
              </Col>
         </Row>
        <Row style={{marginBottom: "5px"}}>
              <Col><b>Size of Plant</b></Col>
              <Col>
                    <Input type="select" onChange={event => {
                               setSize(event.target.value);
                          }}>
                          <option value=""></option>
                          <option value="Tiny">Tiny (less than 1 inch)</option>
                          <option value="Small">Small (about 3 inches across)</option>
                          <option value="Medium">Medium (between 3 inches and 12 inches across)</option>
                          <option value="Bush">Shrub (between 1 ft. and 3 ft across)</option>
                          <option value="Small Tree">Small Tree (under 20ft)</option>
                          <option value="Medium Tree">Medium Tree (20-50 ft tall)</option>
                          <option value="Large Tree">Large Tree (greater than 50 ft tall)</option>
                    </Input>

                   {errors.size && <p>{errors.size}</p>}
              </Col>
         </Row>
          <Row style={{marginBottom: "5px"}}>
              <Col><b>Spacing (also put the units, for example, feet or inches)</b></Col>
              <Col>
                   <Input type="text"  onChange={event => {
                               setSpacing(event.target.value);
                          }}
>
                   </Input>

                   {errors.spacing && <p>{errors.spacing}</p>}
              </Col>
         </Row>
         <Row style={{marginBottom: "5px"}}>
              <Col><b>Yield in ounces or pounds per plant (include unit of measure)</b></Col>
              <Col>
                   <Input type="text"  onChange={event => {
                               setYieldPerPlant(event.target.value);
                          }}
>
                   </Input>
              </Col>
         </Row>

                   <Row>
          <Col md={3}>Add Card Icon Here (342x79 pixel dimensions)</Col>
          <Col md={12}>
                  {selectedIcon.length==0 && <Dropzone
                      style={{"width" : "100%", "height" : "20%", "border" : "1px solid black"}}
                      onDrop={acceptedFiles => {
                           handleIcon(acceptedFiles)
                      }}
                   >
             {({ getRootProps, getInputProps }) => (
                  <div
                className="dz-message needsclick"
                      {...getRootProps()}
               >
                  <input {...getInputProps()} />
                  <h4>Click here to upload Photo</h4>
                   {errors.selectedIcon && <p>{errors.selectedIcon}</p>}
               </div>
         )}
      </Dropzone>}
          </Col>
           </Row>
            <Row>
          <Col md={6}>
           {selectedIcon.map((f, i) => {
                            return (
                              <Card
                                className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                key={i + "-file"}
                              >
                                <div className="p-2">
                                  <Row className="align-items-center">
                                    <Col className="col-auto">
                                      <img
                                        data-dz-thumbnail=""
                                        height="80"
                                        className="avatar-sm rounded bg-light"
                                        alt={f.name}
                                        src={f.preview}
                                      />
                                    </Col>
                                    <Col>
                                      <Link
                                        to="#"
                                        className="text-muted font-weight-bold"
                                      >
                                        {f.name}
                                      </Link>
                                      <p className="mb-0">
                                        <strong>{f.formattedSize}</strong>
                                      </p>
                                    </Col>
                                  </Row>
                                </div>
                              </Card>
                            )
                          })}
                     </Col>

          </Row>

<Row>
          <Col md={3}>Add Designer Icon Here (75x75 pixel dimensions)</Col>
          <Col md={12}>
                  {selectedDesignerIcon.length==0 && <Dropzone
                      style={{"width" : "100%", "height" : "20%", "border" : "1px solid black"}}
                      onDrop={acceptedFiles => {
                           handleDesignerIcon(acceptedFiles)
                      }}
                   >
             {({ getRootProps, getInputProps }) => (
                  <div
                className="dz-message needsclick"
                      {...getRootProps()}
               >
                  <input {...getInputProps()} />
                  <h4>Click here to upload Photo</h4>

                   {errors.selectedDesignerIcon && <p>{errors.selectedDesignerIcon}</p>}
               </div>
         )}
      </Dropzone>}
          </Col>
           </Row>
            <Row>
          <Col md={6}>
           {selectedDesignerIcon.map((f, i) => {
                            return (
                              <Card
                                className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                key={i + "-file"}
                              >
                                <div className="p-2">
                                  <Row className="align-items-center">
                                    <Col className="col-auto">
                                      <img
                                        data-dz-thumbnail=""
                                        height="80"
                                        className="avatar-sm rounded bg-light"
                                        alt={f.name}
                                        src={f.preview}
                                      />
                                    </Col>
                                    <Col>
                                      <Link
                                        to="#"
                                        className="text-muted font-weight-bold"
                                      >
                                        {f.name}
                                      </Link>
                                      <p className="mb-0">
                                        <strong>{f.formattedSize}</strong>
                                      </p>
                                    </Col>
                                  </Row>
                                </div>
                              </Card>
                            )
                          })}
                     </Col>

          </Row>



         <Row style={{ paddingTop: "10px", paddingBottom: "10px"}}>
              <Col md="4"/>
              <Col md="2">
                   <Button
                       onClick={e => { savePlant()  }}
                       color="success"
                       className="btn-sm"
                    >
                     Save Plant
                   </Button>

              </Col>

            </Row>

		  </Form>
	

        </Container>
      </div>
    </React.Fragment>
  )
}

Hackathon.propTypes = {
  users: PropTypes.array,
  onGetUsers: PropTypes.func,
}

const mapStateToProps = (state, ownProps) => {
  console.log (state)
 return({
    dataentryplants: state.hackathon.plants,
    dataentryanimals: state.hackathon.animals
  })
}

const mapDispatchToProps = dispatch => ({
  onGetUsers: () => dispatch(getUsers()),
  onAddDataEntryPlant: (plant) => dispatch(addDataEntryPlant(plant)),
  onGetDataEntryPlants: () => dispatch(getDataEntryPlants()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Hackathon)
